import React from 'react';
import "./Error.scss";
import { FIELD_MAX_LENGTHS } from '../../../Utils/Constants';

const InfoTab = ({ formData, isEditable, handleChange, errors = {} }) => {
    const fieldMaxMap = {
        first_name: FIELD_MAX_LENGTHS.firstName,
        last_name: FIELD_MAX_LENGTHS.lastName,
        email_id: FIELD_MAX_LENGTHS.email,
        contact_no: FIELD_MAX_LENGTHS.contact,
    };

    const renderField = (label, name, type = 'text') => (
        <div className="cp-split" style={{ position: 'relative' }} key={name}>
            <label className="fi-label">{label} <span>*</span></label>
            <input
                type={type}
                name={name}
                maxLength={fieldMaxMap[name]}
                className={`common-input ${!isEditable ? 'readonly-input' : ''} ${errors[name] ? 'error' : ''}`}
                value={formData[name]}
                onChange={handleChange}
                disabled={!isEditable || name === 'email_id'}
            />
            <span className={`error-text ${errors[name] ? 'active' : ''}`}>
                {errors[name] || ' '}
            </span>
        </div>
    );

    return (
        <div className="aptab-inner">
            {renderField('First Name', 'first_name')}
            {renderField('Last Name', 'last_name')}
            {renderField('Email', 'email_id', 'email')}
            {renderField('Contact No.', 'contact_no')}


        </div>
    );
};

export default InfoTab;
